import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components/components.module';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ReactiveFormsModule } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { DropdownModule } from 'primeng/dropdown';
import { RouterLink, RouterModule } from '@angular/router';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { FormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DialogModule } from 'primeng/dialog';
import { PipesModule } from '../../pipes/pipes.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { WorkflowComponent } from './workflow.component';
import { WorkflowCreatorComponent } from './workflow-creator/workflow-creator.component';
import { WorkflowEditComponent } from './workflow-edit/workflow-edit.component';
import { WorkflowDetailsComponent } from './workflow-details/workflow-details.component';
import { WorkflowLogComponent } from './workflow-log/workflow-log.component';
import { WorkflowTestComponent } from './workflow-test/workflow-test.component';
import { WorkflowBoardComponent } from './workflow-board/workflow-board.component';
import { CommonLpModule } from 'projects/app-ui/src/app/legacy/page/landingpage/common-lp/common-lp.module';
import { MenuModule } from 'primeng/menu';
import {SidebarModule} from 'primeng/sidebar';
import { WorkflowStepConfigModule } from '../../components/workflow-step-config/workflow-step-config.module';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { CheckboxModule } from 'primeng/checkbox';

const cmp = [
    WorkflowComponent,
    WorkflowCreatorComponent,
    WorkflowEditComponent,
    WorkflowDetailsComponent,
    WorkflowLogComponent,
    WorkflowTestComponent,
    WorkflowBoardComponent
];
@NgModule({
    declarations: [...cmp],
    imports: [
        CommonModule,
        ComponentsModule,
        TableModule,
        ConfirmDialogModule,
        ToastModule,
        ReactiveFormsModule,
        RippleModule,
        DropdownModule,
        RouterLink,
        TimelineModule,
        CardModule,
        TieredMenuModule,
        InputTextModule,
        TextareaModule,
        ConfirmPopupModule,
        FormsModule,
        SelectButtonModule,
        DialogModule,
        PipesModule,
        DragDropModule,
        MenuModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
            isolate: false,
        }),
        CommonLpModule,
        RouterModule,
        SidebarModule,
        WorkflowStepConfigModule,
        TooltipModule,
        TagModule,
        CheckboxModule
    ],
    exports: [...cmp],
})
export class WorkflowModule {}
